export class InvtListModel {
    unit_price: number
    item_no: number
    item_clinic: number
    item_presc_code: string

    constructor(
        unit_price: number,
        item_no: number,
        item_clinic: number,
        item_presc_code: string
    ) {
        this.unit_price = unit_price
        this.item_no = item_no
        this.item_clinic = item_clinic
        this.item_presc_code = item_presc_code
    }
}